module.exports = __webpack_public_path__ + "img/fontello.b69f9a7e.svg";